import { render, staticRenderFns } from "./InfoPanelAir.vue?vue&type=template&id=288293c0&scoped=true"
import script from "./InfoPanelAir.vue?vue&type=script&lang=ts"
export * from "./InfoPanelAir.vue?vue&type=script&lang=ts"
import style0 from "./InfoPanelAir.vue?vue&type=style&index=0&id=288293c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288293c0",
  null
  
)

export default component.exports